import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { APIIPRegisterService } from '../../_services/ip-register/API-ipregister';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { b } from '@angular/core/src/render3';
import { Router } from '@angular/router';
import { APIConsentService } from '../../_services/consent/API-consent';

export interface Element {
  selectPack: string;
  packName: string;
  numofReq: string;
  validity: string;
  packRate: string;
}

let now = new Date();
@Component({
  selector: 'app-activate-digital-consent',
  templateUrl: './activate-digital-consent.component.html',
  styleUrls: ['./activate-digital-consent.component.css']
})
export class ActivateDigitalConsentComponent implements OnInit {
  digitalForm: FormGroup;
  response: any
  dataSource: any;

  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['selectPack', 'packName', 'numofReq', 'validity', 'packRate'];

  //  Elementdata: Element[] = [
  //   {selectPack: '1 K Consents', packName: '1 K Consents', numofReq: '1000 Requests', validity: '30 Days',packRate: 'Rs 2 K'},
  //   {selectPack: '1 K Consents', packName: '5 K Consents', numofReq: '5000 Requests', validity: '90 Days',packRate: 'Rs 7 K'},
  //   {selectPack: '1 K Consents', packName: '10 K Consents', numofReq: '10000 Requests', validity: '180 Days',packRate: 'Rs 12 K'},
  //   {selectPack: '1 K Consents', packName: '30 K Consents', numofReq: '30000 Requests', validity: '270 Days',packRate: 'Rs 30 K'},
  //   {selectPack: '1 K Consents', packName: '50 K Consents', numofReq: '50000 Requests', validity: '365 Days',packRate: 'Rs 45 K'},
  //   {selectPack: '1 K Consents', packName: '1 L Consents', numofReq: '100000 Requests', validity: '365 Days',packRate: 'Rs 75 K'},
  // ];
  entityId: any;
  creditBalance: any;
  EntityName: any;
  expiryDate: any;
  CreditBalance: any;
  ExpiryDate: any;
  id: any;
  data: any;
  packRate:any;
  
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

  constructor(private fb: FormBuilder,
    private cst: APIConsentService,
    private ip: APIIPRegisterService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private router: Router) {

    this.EntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME)
    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)

  }


  ngOnInit() {
    this.digitalForm = this.fb.group({

      entityName: [''],
      creditBalance: [''], //To allow from 15 to 19 digits
      expirydate: [''],
      id: ['', [Validators.required]]
    });

    this.digitalForm.controls['entityName'].setValue(this.EntityName);
    this.fetchcreditbal();
    this.getratecard();
  }


  get f() { return this.digitalForm.controls; }

  fetchcreditbal() {
    var data = {
      EntityID: this.entityId
    }

    this.cst.fetchcreditbalance(data)
      .subscribe(r => {
        if (r.Status == "Success") {
          // this.$modal.successModal({
          //   title: 'Activate Digital Consent Credit Pack',
          //   msg: r.message
          // });
          this.digitalForm.controls['creditBalance'].setValue(r.CreditBal);
          this.digitalForm.controls['expirydate'].setValue(r.Expiry_Dt);
        }
        else {
          this.$modal.errorModal({
            title: 'Activate Digital Consent Credit Pack',
            msg: r.message
          });

        }
      })

  }

  getratecard() {
    this.cst.getratecard()
      .subscribe({
        next: response => {
          this.dataSubject.next(response.Values);
          this.dataSource = new MatTableDataSource();

          this.dataSource = new MatTableDataSource(response.Data);
          this.dataSource.paginator = this.paginator;
        }
      });
  }
  onSubmit() {
    //console.log(this.id)
    if (this.digitalForm.invalid) {
      this.$modal.errorModal({
        title: 'Activate Digital Consent Credit Pack',
        msg: 'Please select a pack'
      });
      return;
    }
    else {
      var data = {
        EntityID: this.entityId,
        RCID: this.id   
      }
     // let TransactionAmount = this.digitalForm.get("packRate").value;
      this.cst.buyratecard(data)
        .subscribe(r => {
          if (r.Status == "Success") {
            // this.$modal.successModal({
            //   title: 'Activate Digital Consent Credit Pack',
            //   msg: r.message
            // });
            this.db.set(Constants.SESSSION_STORAGE, Constants.PAYMENTFORURN,r.PAYMENTFORURN );
            let amt = r.Amount;
            amt = amt + (amt * 18 / 100);	
            this.db.set(Constants.SESSSION_STORAGE, Constants.TRANSACTIONAMOUNT, amt);
            this.db.set(Constants.SESSSION_STORAGE, Constants.MODULEFORPAYMENT, 'DIGITAL CONSENT ACQUISITION');
            this.router.navigate(['payment-submit'])
          }
          else {
            this.$modal.errorModal({
              title: 'Activate Digital Consent Credit Pack',
              msg: r.Message
            });

          }
        })
    }
  }

  updateid(rcid) {
    this.id = rcid
  }

}
